var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdfSingleViewer',{ref:`pdfSingleViewer${_vm.id}`,attrs:{"zoomValue":_vm.zoomValue,"client":true,"zoom":true,"zoomMax":5,"shown":true,"pdflibSrc":_vm.pdflibSrc,"pdfWorkerSrc":_vm.pdfWorkerSrc,"cmapUrl":_vm.cmapUrl,"pdfUrl":_vm.pdfUrl,"withCredentials":_vm.withCredentials},on:{"changeZoomValue":_vm.handleChangeZoomValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }